import axios, { AxiosError } from "axios";
import { API_GATEWAY, PR_DEP } from "../../config/globalVariables";
import header from "../../config/requestHeader";
import { handleAxiosError } from "../../helpers/handleAxiosError";

export const authClient = axios.create({
  baseURL: `${API_GATEWAY + PR_DEP}/auth`,
  headers: header,
});

authClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error instanceof AxiosError && error.isAxiosError && error.response) {
      handleAxiosError(error);
    }
    throw error;
  }
);
